import React, {PropTypes} from 'react';
import {formatCurrency} from 'shared/util/formatCurrency';
Number.prototype.formatCurrency = formatCurrency;

const AuditTeamLedgerDetail = ({
  details
}) => (
  <div>
      { details && details.length > 0 ? <h3>{'New Transactions'}</h3> : null }
    <div className="list-group">
      { details ? details.map((item, index) => (
      
      <div className="list-group-item-labeled"
            key={index} > 
        <div className="list-group-item-labeled-child"
          style={{width: 100}}>
          <span>{'Transaction Type'}</span>
          <span>{item.transactionType}</span>
        </div> 
        <div className="list-group-item-labeled-child"
          style={{width: 100}}>
          <span>{'Date'}</span>
          <span>{`${item.date}`}</span>
        </div> 
        <div className="list-group-item-labeled-child"
          style={{width: 70}}>
          <span>{'Amount'}</span>
          <span>{`$${item.amount}`}</span>
        </div>
        <div className="list-group-item-labeled-child"
          style={{width: 200}}>
          <span>{'Description'}</span>
          <span>{item.description}</span>
        </div> 
        <div className="list-group-item-labeled-child"
          style={{width: 200}}>
          <span>{'Notes'}</span>
          <span>{item.notes}</span>
        </div>  
      </div>
        )) : null}
    </div> 
  </div> 
);

AuditTeamLedgerDetail.propTypes = { 
  details: PropTypes.arrayOf(PropTypes.object)
};

AuditTeamLedgerDetail.defaultProps = {
};

export default AuditTeamLedgerDetail;



// WEBPACK FOOTER //
// ./src/features/admin/audit/teamLedger/AuditTeamLedgerDetail.jsx